import { useMemo } from "react";
import type { ConfigurableProduct, StepBulkGroup } from "../steps/types";

/**
 * Gives a step the group it configures, whether or not its host supports bulk.
 *
 * Hosts driving a single product (labs, product creation) pass no group: the
 * step then configures a group of one, so every view can read `isBulkMode`,
 * `groupProducts` and `groupTeeth` without branching on the host.
 */
export const useStepBulkGroup = (
  product: ConfigurableProduct,
  bulkGroup: StepBulkGroup | undefined
): StepBulkGroup =>
  useMemo(
    () =>
      bulkGroup ?? {
        isBulkMode: false,
        groupProducts: [product],
        groupTeeth: [...product.teeth],
      },
    [bulkGroup, product]
  );
